module.exports = __webpack_public_path__ + "static/media/03.d1e0ad13.jpg";